
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import api from "@/services/api"
import { namespace, Getter, Mutation, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { ViewSummary } from "@/types/views/viewSummary"
import ViewFolders from "./ViewFolders.vue"
import { View } from "@/types/view"
import { cloneDeep, get } from "lodash"

const caseStore = namespace("cases")

	@Component({
		components: {
			"scrollbar": VuePerfectScrollbar,
			"view-folders": ViewFolders
		}
	})
export default class CaseFilters extends Vue {
	@Getter("getScreenWidth") public screenWidth!: number;

	@Prop()
	views!: ViewSummary[];

	@Prop()
	activeViewId!: string | null;

	public gotoPage (viewId: string) {
		this.$emit("changeView", viewId)
	}
}
